import { c as _c } from "react/compiler-runtime";
import './recent-activity-panel.scss';
import React from 'react';
export type RecentActivityPanelProps = {
  heading: string;
  subheading: string;
  items: React.ReactNode[];
};
export const RecentActivityPanel: React.FC<RecentActivityPanelProps> = t0 => {
  const $ = _c(12);
  const {
    heading,
    subheading,
    items
  } = t0;
  let t1;
  if ($[0] !== heading) {
    t1 = <div className="RecentActivityPanel__title label-potent label-lg md:label-lg md:label-potent label-neutral-amplified">{heading}</div>;
    $[0] = heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subheading) {
    t2 = <div className="RecentActivityPanel__subtitle body-sm">{subheading}</div>;
    $[2] = subheading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="pl-comfy-lg pt-comfy-sm pb-comfy-sm flex flex-1 flex-col gap-snug-md">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== items) {
    t4 = <div className="RecentActivityPanel__items flex flex-1 flex-col gap-snug-xl w-full">{items}</div>;
    $[7] = items;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="RecentActivityPanel flex items-center p-snug-lg rounded-md w-full relative"><div className="RecentActivityPanel__content flex flex-1 flex-col">{t3}{t4}</div></div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};